import { Dictionary, IWithScale, IWithSortBy, IWithSubViews } from "../../../entities/common";
import { Views } from "../../../store/services/viewSaver";

export type SummaryData = {
    effort: number | null,
    completedWork: number,
    remainingWork: number | null,
    hasValue: boolean
}

export type TimeType = 'Effort' | 'CompletedWork' | 'RemainingWork' | 'BaselineEffort';

export const timeTypesConfigMap: Dictionary<{type: TimeType, title: string, className: string}> = 
{
    'Effort': {type: 'Effort', title: 'Effort', className: 'plan'},
    'CompletedWork': {type: 'CompletedWork', title: 'Completed Work', className: 'actual'},
    'RemainingWork': {type: 'RemainingWork', title: 'Remaining Work', className: 'remaining'},
    'BaselineEffort': {type: 'BaselineEffort', title: 'Baseline Effort', className: 'baseline'}
}
export const allTimeTypes:  TimeType[] = ['Effort', 'CompletedWork', 'RemainingWork', 'BaselineEffort'];
export const defaultTimeType: TimeType[] = ['Effort', 'CompletedWork', 'RemainingWork'];

export type IWithTimeType = { timeType?: TimeType[]; }
export type UsagesControlSettings = IWithSubViews & IWithScale & IWithSortBy & IWithTimeType & {
    grouping: 'Resource' | 'Task',
    displayFields: string[];
}

export type WorkloadControlSettings = {
    viewType: Views;
    usage: UsagesControlSettings;
}
    
export const getTimeTypes = (controlSettings: WorkloadControlSettings) => controlSettings.usage?.timeType
    ? Object.keys(controlSettings.usage.timeType).filter(_ => controlSettings.usage.timeType![_]) as TimeType[]
    : defaultTimeType
